import { render, staticRenderFns } from "./myAgentOrder.vue?vue&type=template&id=f2e72814&scoped=true&"
import script from "./myAgentOrder.vue?vue&type=script&lang=js&"
export * from "./myAgentOrder.vue?vue&type=script&lang=js&"
import style0 from "./myAgentOrder.vue?vue&type=style&index=0&id=f2e72814&lang=less&scoped=true&"
import style1 from "./myAgentOrder.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e72814",
  null
  
)

component.options.__file = "myAgentOrder.vue"
export default component.exports